//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Box, useDisclosure } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { RequestFormWrapper } from "../../../../../home-tutoring/request-flow/ClientRequestForm";
import { LessonScheduleSwitcher } from "../../../../../home-tutoring/request-flow/LessonScheduleSwitcher";
import { AdminEditDrawer } from "../../../../../home-tutoring/request-flow/TutorsExistModal";
import FormWrapper from "../../../../../home-tutoring/request-flow/components/FormWrapper";
import { IViewModelReturnType } from "../../../../../home-tutoring/request-flow/old";
import ChildFormPage from "../../../../../home-tutoring/request-flow/old/components/ChildFormPage";
import { scrollToId } from "../../../../../utils/functions";
import TeacherFormPage from "../../../../../home-tutoring/request-flow/TeacherFormPage";

export const AdminEditRequestControl: React.FC<{
  viewModel: IViewModelReturnType;
  onSubmit?: (viewModel?: IViewModelReturnType) => Promise<any>;
  formType?: "edit-request" | "no-of-tutors";
  render?: (params?: any) => any;
}> = observer(
  ({
    viewModel,
    formType = "edit-request",
    onSubmit = () => Promise.resolve({}),
    render = () => null,
    ...rest
  }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [loading, setLoading] = React.useState(false);
    const buttonProps = {
      onClick: onOpen,
      isLoading: loading,
      loadingText: "Updating Request",
    };
    return (
      <>
        {render(buttonProps)}
        {isOpen && (
          <EditClientRequestForm
            viewModel={viewModel}
            isOpen={isOpen}
            onClose={onClose}
            formType={formType}
            onSubmit={() => {
              setLoading(true);
              onSubmit(viewModel)
                .then(() => {
                  setLoading(false);
                  viewModel.setLoading(false);
                  onClose();
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error);
                });
            }}
          />
        )}
      </>
    );
  }
);

export const EditClientRequestForm: React.FC<{
  viewModel: IViewModelReturnType;
  isOpen: boolean;
  formType?: "edit-request" | "no-of-tutors";
  onClose: any;
  onSubmit: any;
}> = observer(
  ({
    viewModel,
    onSubmit,
    onClose,
    formType = "edit-request",
    isOpen = false,
    ...rest
  }) => {
    return (
      <AdminEditDrawer
        size="xl"
        closeOnOverlayClick
        isOpen={isOpen}
        onClose={onClose}
      >
        {formType === "edit-request" ? (
          <ClientRequestForm onSubmit={onSubmit} viewModel={viewModel} />
        ) : (
          <SelectNoOFTeachers onSubmit={onSubmit} viewModel={viewModel} />
        )}
      </AdminEditDrawer>
    );
  }
);

const SelectNoOFTeachers = ({
  viewModel,
  onSubmit,
  ...rest
}: {
  viewModel: IViewModelReturnType;
  onSubmit: () => void;
}) => {
  const stepsArray = [
    { key: "child-details", name: "Child details", completed: false },
    { key: "teacher-selection", name: "Teacher selection", completed: false },
    { key: "lesson-schedule", name: "Lesson schedule", completed: false },
    { key: "lesson-location", name: "Lesson location", completed: false },
    { key: "contact-information", name: "Contact info", completed: false },
  ];
  const [formIndex, setFormIndex] = React.useState(1);
  const [loadingText, setLoadingText] = React.useState("");
  const [steps, setSteps] = React.useState(stepsArray);
  const [activeStep, setActiveStep] = React.useState("child-details");

  return (
    <Box minH="100vh" bg={["white", "neutral.200"]} {...rest}>
      <RequestFormWrapper
        formIndex={formIndex}
        viewModel={viewModel}
        activeStep={activeStep}
        steps={steps}
      >
        <FormWrapper activeForm={formIndex}>
          <TeacherFormPage
            onSubmit={(data) => {
              // setFormIndex(2)
              viewModel.teacherSelectStore.onSubmitForm(data).then(() => {
                setLoadingText("Loading");
                onSubmit();
              });
            }}
            initialValues={{
              ...viewModel.teacherSelectStore.toJSON(),
            }}
            nextButtonText="Save Changes"
            updateFormIndex={() => setFormIndex(2)}
            loading={viewModel.loading}
            teacherSplitOptions={viewModel.childStore.teacherSplitOptions()}
            viewModel={viewModel.teacherSelectStore}
          />
        </FormWrapper>
      </RequestFormWrapper>
    </Box>
  );
};

const ClientRequestForm: React.FC<{
  viewModel: IViewModelReturnType;
  onSubmit: () => void;
}> = observer(({ viewModel, onSubmit, ...rest }) => {
  const stepsArray = [
    { key: "child-details", name: "Child details", completed: false },
    { key: "teacher-selection", name: "Teacher selection", completed: false },
    { key: "lesson-schedule", name: "Lesson schedule", completed: false },
    { key: "lesson-location", name: "Lesson location", completed: false },
    { key: "contact-information", name: "Contact info", completed: false },
  ];
  const [formIndex, setFormIndex] = React.useState(1);
  const [loadingText, setLoadingText] = React.useState("");
  const [steps, setSteps] = React.useState(stepsArray);
  const [activeStep, setActiveStep] = React.useState("child-details");

  const handleFormSubmit = (id, presentStep) => {
    setFormIndex((index) => index + 1);
    setActiveStep(id);
    setSteps(
      [...steps].map((object) => {
        if (object.key === presentStep) {
          return {
            ...object,
            completed: true,
          };
        } else return object;
      })
    );
    scrollToId(id);
  };
  return (
    <Box minH="100vh" bg={["white", "neutral.200"]} {...rest}>
      <RequestFormWrapper
        formIndex={formIndex}
        viewModel={viewModel}
        activeStep={activeStep}
        steps={steps}
      >
        <FormWrapper
          activeForm={formIndex}
          customFormIds={{
            1: "student-details",
            2: "lesson-schedule",
          }}
        >
          <ChildFormPage
            dataType={viewModel.academicData}
            viewModel={viewModel.childStore}
            customerType={viewModel.customerType}
            loading={viewModel.childStore.loading}
            updateFormIndex={() => {}}
            toNextPage={async (o) => {
              await viewModel.childStore.onSubmitForm(o);
              handleFormSubmit("lesson-schedule", "child-details");
            }}
            displayGender
            nextButtonText={`Next: Lesson Schedule`}
          />
          <LessonScheduleSwitcher
            loading={viewModel.lessonScheduleStore.loading}
            teacherOption=""
            numberOfTeachers={1}
            nextButtonText="Save Changes"
            viewModel={viewModel.lessonScheduleStore}
            onSubmit={(data) => {
              setLoadingText("Saving");
              return viewModel.lessonScheduleStore
                .onSubmitForm(data)
                .then((tutorExistsResult) => {
                  setLoadingText("Loading");
                  onSubmit();
                });
            }}
          />
        </FormWrapper>
      </RequestFormWrapper>
    </Box>
  );
});
